import client, { PaginatedResponse } from '@/utils/client'
import urls from '@/utils/urls'

var defaultState = {}

export const mutations = {
}

export const getters = {
}

export const actions = {
  setPaymentToken ({dispatch}, {token}) {
    return client.post(urls.payment.token(), {token}).then(response => dispatch('profile/getCurrentUser', null, { root: true }))
  },
  async removeCard ({dispatch}) {
    await client.delete(urls.payment.token())
    return dispatch('profile/getCurrentUser', null, { root: true })
  },
  listPayments (ctx) {
    return client.get(urls.payment.history()).then(response => new PaginatedResponse(response.data))
  },
  listArtistTransactions (ctx, filter) {
    return client
      .get(urls.payment.transactions(), {
        params: filter
      })
      .then(response => new PaginatedResponse(response.data))
  },
  async getArtistPayoutSetupLink (ctx, { next }) {
    const resp = await client.get(urls.payment.setupPayout(), {
      params: {redirect_url: next}
    })
    return resp.data.url
  }
}

export default {
  namespaced: true,
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payment.js